import api from 'plugin/api';

/**
 *  보고서 - 정기심사 브리핑
 */

/**
 *  @description 정기심사 브리핑 API
 */
async function regularReview(params) {
  const url = '/sfsh/report/regRev';

  const response = await api.get(url, { params });
  return response;
}

export { regularReview };
